exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-restock-date[data-v-0a0ea6dd] {\n  color: #626262;\n  font-weight: 700;\n  font-size: 1rem;\n}\n.sales-tax-message[data-v-0a0ea6dd] {\n  font-size: 0.6em;\n  font-style: italic;\n  color: grey;\n  margin-top: 1em;\n  margin-bottom: -10px;\n}", ""]);

// exports
